import _ from 'lodash'
import { decrypt, encrypt } from '@/util/crypto/EntryCrypt'
import API from '@/util/api/API'
import { IEntry, IEntryPartial } from '@/types/entry'
import { REncrypted } from '@/types/crypto'
import { Revision } from '@/store/revision/types'

class StoreAPI {
    public async getPartials(lastUpdated?: string): Promise<IEntryPartial[]> {
        return API.get('store/entries', { lastUpdated })
    }

    public async getEntry(id: string): Promise<IEntry> {
        return API.get(`store/entries/${id}`)
    }

    public async insert(data: IEntry) {
        return API.post('store/entries', data)
    }

    public async update(id: string, data: IEntry) {
        return API.put(`store/entries/${id}`, data)
    }

    public async delete(id: string): Promise<void> {
        return API.delete(`store/entries/${id}`)
    }

    public async updateSortOrder(id: string, sortOrder: number): Promise<IEntry> {
        return API.put(`store/entries/${id}/order`, { sortOrder })
    }

    public async revisions(
        id: string, documentKey: string,
        offset: number, limit: number
    ): Promise<Revision[]> {
        const data = await API.get(`store/revision/${id}?offset=${offset}&limit=${limit}`)
        // attach document key to each revision for decrypting
        data.forEach((revision: any) => {
            revision.pivot = { documentKey }
        })
        return decrypt(data as REncrypted[]) as unknown as Revision[]
    }

    public async getTags(): Promise<string[]> {
        return API.get('store/tags')
    }
}

export default new StoreAPI()
